import { render, staticRenderFns } from "./FilterGoods.vue?vue&type=template&id=cbdd9730&scoped=true"
import script from "./FilterGoods.vue?vue&type=script&lang=js"
export * from "./FilterGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdd9730",
  null
  
)

export default component.exports